/**
 * Cache Service für statische Daten (Kategorien, Altersgruppen)
 * Verwendet localStorage mit TTL (Time To Live)
 */

const CACHE_PREFIX = 'cwwc2026_cache_';
const CACHE_TTL = 5 * 60 * 1000; // 5 Minuten

class CacheService {
  getCacheKey(key) {
    return `${CACHE_PREFIX}${key}`;
  }

  get(key) {
    try {
      const cacheKey = this.getCacheKey(key);
      const cached = localStorage.getItem(cacheKey);
      if (!cached) return null;

      const { data, timestamp } = JSON.parse(cached);
      const now = Date.now();

      // Prüfe ob Cache abgelaufen ist
      if (now - timestamp > CACHE_TTL) {
        localStorage.removeItem(cacheKey);
        return null;
      }

      return data;
    } catch (error) {
      console.warn(`Cache-Fehler beim Lesen von ${key}:`, error);
      return null;
    }
  }

  set(key, data) {
    try {
      const cacheKey = this.getCacheKey(key);
      const cacheData = {
        data,
        timestamp: Date.now()
      };
      localStorage.setItem(cacheKey, JSON.stringify(cacheData));
    } catch (error) {
      console.warn(`Cache-Fehler beim Schreiben von ${key}:`, error);
      // localStorage könnte voll sein oder disabled
    }
  }

  clear(key) {
    try {
      const cacheKey = this.getCacheKey(key);
      localStorage.removeItem(cacheKey);
    } catch (error) {
      console.warn(`Cache-Fehler beim Löschen von ${key}:`, error);
    }
  }

  clearAll() {
    try {
      const keys = Object.keys(localStorage);
      keys.forEach(key => {
        if (key.startsWith(CACHE_PREFIX)) {
          localStorage.removeItem(key);
        }
      });
    } catch (error) {
      console.warn('Cache-Fehler beim Löschen aller Einträge:', error);
    }
  }
}

export default new CacheService();

